const keyDownSet = new Set();

/**
 * Erlaubt globalen Zugriff auf die Info, ob eine Taste zur Zeit gedrückt ist.
 */
export default class KeyState {

    static isAlt() {
        return keyDownSet.has(18);
    }

    static isCtrl() {
        return keyDownSet.has(17);
    }

    static isShift() {
        return keyDownSet.has(16);
    }

    static isAltGr() {
        return keyDownSet.has(255);
    }

    static getKeySet() {
        return keyDownSet;
    }

}

document.onkeydown = function (e) {
    keyDownSet.add(getKey(e));
}

document.onkeyup = function (e) {
    keyDownSet.delete(getKey(e));
}

function getKey(e) {
    return (typeof e.which == "number") ? e.which : e.keyCode;
}
